define([
	"dojo/_base/declare",
	"SiteAdmin/Locale",
	"./AttributeTooltip"
], function(declare,Locale,Tooltip) {

	return declare(Tooltip, {
		_getSuffix: function() {
			return Locale.ATTR_VALIDATION;
		}
	});
});